module.exports = __webpack_public_path__ + "img/icon_VR_W.426d2d1d.svg";